import { computed, defineComponent, reactive, useContext, useCssModule } from '@nuxtjs/composition-api';
import { useA11y } from '~/composables';
export default defineComponent({
    name: 'GalleryHero',
    props: {
        gallery: {
            required: true,
            type: Object,
        },
    },
    emits: ['click'],
    setup(_, { emit }) {
        const a11y = useA11y();
        const context = useContext();
        const css = useCssModule();
        const buttonBind = reactive({
            icon: computed(() => `gallery${a11y.isEnabled ? '-a11y' : ''}`),
            size: computed(() => {
                if (a11y.isEnabled) {
                    return 'large';
                }
                return context.$viewport.match('desktopWide') ? 'big' : 'medium';
            }),
            tag: 'div',
            theme: 'yellow',
        });
        function handleClick(event) {
            emit('click', event);
        }
        function isImageVertical(image) {
            const { height = 0, width = 0 } = image?.metadata || {};
            return height > width;
        }
        return {
            a11y,
            buttonBind,
            css,
            handleClick,
            isImageVertical,
        };
    },
});
